<template>
    <div class="center-column">
        <h2>References</h2>
        <References />
    </div>
</template>
<script>
import References from '../components/References.vue'

export default {
    name: "ReferencesPage",
    components: {
        References
    }
}
</script>